module.exports = __webpack_public_path__ + "img/facebook.4fa522a6.svg";